import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-initial-modal',
  templateUrl: './initial-modal.component.html',
  styleUrls: ['./initial-modal.component.scss'],
  standalone: false,
})

export class InitialModalComponent implements OnInit {
  @Input() isModalOpen = false;
  @Input() arrived = false;
  @Input() confirmLoading = false;
  @Input() cancelLoading = false;
  @Output() close: EventEmitter<void> = new EventEmitter<void>();
  @Output() notArrived: EventEmitter<void> = new EventEmitter<void>();
  @Output() goToLoaderPage: EventEmitter<void> = new EventEmitter<void>();
  constructor() { }
  ngOnInit() { }

  get buttonsDisabled(): boolean {
    return this.confirmLoading || this.cancelLoading;
  }

  initialModalButtonStyles(
    backgroundColor: string,
    className?: string
  ): { [key: string]: string } {
    const styles: { [key: string]: string } = {
      width: '100%',
      maxWidth: '377px',
      maxHeight: '40px',
      backgroundColor,
      color: '#fff',
      borderRadius: '15px',
    };
    if (className) {
      styles['class'] = className;
    }
    return styles;
  }

  closeModal() {
    this.close.emit();
  }
  providerNotArrived() {
    this.notArrived.emit()
  }
}
